export default __webpack_public_path__ + "static/media/img3.917a6e74.PNG";